module.exports = __webpack_public_path__ + "img/ceshizhongxin.eb6be493.png";